import { Link } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Badge } from "@odingard/design-system";
import { ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { api } from "../../lib/api";

const PROPOSAL_ENTITLEMENTS = [
  { key: "proposal_ai.enabled", label: "Proposal AI" },
  { key: "proposal_ai.opportunity_intelligence", label: "Opportunity Intelligence" },
  { key: "proposal_ai.authoring", label: "Authoring" },
  { key: "proposal_ai.government_compliance", label: "Government & Compliance" },
  { key: "proposal_ai.connected_intelligence", label: "Connected Intelligence" },
  { key: "proposal_ai.analytics", label: "Analytics" },
];

export function PaiSettings() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => (await api.entitlements(orgId)).entitlements, [orgId]);

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Proposal AI Settings</h1>
          <p>Capability entitlements for {activeOrg?.name}. Billing is managed in Studio.</p>
        </div>
        <div className="ods-row">
          <Link to="/studio/billing"><Button size="sm" variant="secondary">Billing</Button></Link>
          <Link to="/studio/usage"><Button size="sm" variant="secondary">Usage</Button></Link>
          <Link to="/studio/seats"><Button size="sm" variant="secondary">Seats</Button></Link>
        </div>
      </div>

      {state.loading && <LoadingState label="Loading entitlements…" />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {state.data && (
        <Card>
          <CardHeader title="Capabilities" />
          <CardBody>
            <div className="ods-stack">
              {PROPOSAL_ENTITLEMENTS.map((ent) => {
                const row = state.data!.find((e) => e.key === ent.key);
                const active = row && ["ALLOWED", "TRIAL"].includes(row.status);
                return (
                  <div key={ent.key} className="ods-row" style={{ justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid var(--ods-color-line)" }}>
                    <div>
                      <div style={{ fontWeight: 600 }}>{ent.label}</div>
                      <span style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}>{ent.key}</span>
                    </div>
                    {active ? (
                      <Badge tone={row!.status === "TRIAL" ? "info" : "success"}>{row!.status === "TRIAL" ? "Trial" : "Active"}</Badge>
                    ) : (
                      <Badge tone="warning">Not enabled</Badge>
                    )}
                  </div>
                );
              })}
            </div>
          </CardBody>
        </Card>
      )}
    </>
  );
}
